/**
 * PriceBlock — abonnementsprijs (€ 9,95) in emerald accent.
 * Eén consistent prijsblok voor landing, hero en app.
 */
import { psCls } from '@/lib/powersure-theme';

export default function PriceBlock({
  primary = '€ 9,95',
  unit = 'per maand',
  footnote = 'Eerste 3 maanden, daarna € 14,95 per maand · maandelijks opzegbaar',
  label = 'Abonnement',
  paymentNote = 'Veilig betalen met creditcard',
  testId = 'ps-price-block',
  className = '',
}) {
  return (
    <div className={`${psCls.cardEmerald} px-4 py-3 ${className}`} data-testid={testId}>
      <div className="text-[10.5px] uppercase tracking-[0.18em] font-semibold text-emerald-300/90">
        {label}
      </div>
      <div className="flex items-baseline gap-1.5 mt-1">
        <span
          className="text-3xl font-semibold text-white"
          style={{ fontFamily: 'Outfit' }}
          data-testid={`${testId}-amount`}
        >
          {primary}
        </span>
        <span className="text-sm text-white/80">{unit}</span>
      </div>
      <div className="text-xs text-white/70 mt-1">{footnote}</div>
      {paymentNote && (
        <div className="text-[11px] text-white/55 mt-1.5">{paymentNote}</div>
      )}
    </div>
  );
}
